import PropTypes from 'prop-types';
import React from 'react';
import session from '../../../services/sessionService';
import {userLevels} from '../../helpers/constants';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';

import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';

import events from '../../../lib/events.js';

class EditableImageUpload extends React.PureComponent {
  static displayName = 'EditableImageUpload';

  static propTypes = {
    edit: PropTypes.bool,
    image: PropTypes.string,
    label: PropTypes.string.isRequired,
    setEdit: PropTypes.func.isRequired,
    description: PropTypes.string,
  };

  state = {
    imageURL: null,
    imageScale: 1,
  };

  onDrop = (files) => {
    if (files.length !== 1) {
      events.publish('error.user', {message: 'Too many files'});
      return;
    }

    let img = new Image();
    let _URL = window.URL || window.webkitURL;

    img.onload = () => {
      this.setState({imageURL: img.src});
    };
    img.onerror = () => {
      events.publish('error.user', {message: 'Invalid file type'});
    };
    img.src = _URL.createObjectURL(files[0]);
  };

  onOpenClick = () => {
    this.refs.dropzone.open();
  };

  getImage = () => {
    if (this.state.imageURL) {
      return this.refs.image.getImage().toDataURL('image/png');
    }
    return null;
  };

  clear = () => {
    this.setState({imageURL: null, imageScale: 1});
  };

  updateScale = (e) => {
    this.setState({
      imageScale: parseFloat(e.target.value),
    });
  };

  render() {
    let inner;

    if (this.props.edit && this.state.imageURL) {
      inner = <div>
        <AvatarEditor
          ref='image'
          image={this.state.imageURL}
          width={225}
          height={171}
          border={20}
          scale={this.state.imageScale} />
        <label><FormattedMessage id="image.scale.image" /></label>

        {/* Need onMouseUp for IE since there is a bug in react where onChange doesn't fire in IE for range inputs */}
        <input type='range' max='5' min='0.1' step='0.1'
          value={this.state.imageScale}
          onChange={this.updateScale}
          onMouseUp={this.updateScale} />
      </div>;
    }

    if (this.props.edit && !this.state.imageURL) {
      inner = <div className='layout-image-upload-dashed'>
        <Dropzone ref='dropzone' type='file' onDrop={this.onDrop} accept='image/*' style={{
          padding: 20,
          border: 0,
          width: '100%',
          height: '100%',
          textAlign: 'center',
        }}>
          <div>
            <FormattedMessage id="file.draw.image.file" /> <a><FormattedMessage id="general.browse" /></a>
            <i className='bl bl-screenshot screenshot-image' />
          </div>
        </Dropzone>
      </div>;
    }

    if (!this.props.edit && !this.props.image && !session.getUser().privileges.level >= userLevels.dealerAdmin) {
      inner = <div className='layout-image-upload-dashed'>
        <div className='set-edit'><FormattedMessage id="image.upload.logo.click" /> <a onClick={this.props.setEdit}><FormattedMessage id="general.edit" /></a>.</div>
      </div>;
    } else if (!this.props.edit && !this.props.image) {
      inner = <div className='layout-image-upload-dashed' />;
    }

    if (!this.props.edit && this.props.image) {
      inner = <div>
        {/* Add last mod timestamp on this page only so image isn't cached */}
        <img src={this.props.image + '?lastmod=' + moment().valueOf()} style={{width: '100%'}} />
      </div>;
    }

    return <div className='form-group layout-image-upload'>
      <label>{this.props.label}</label>
      {this.props.description ?
        <p className='description'>{this.props.description}</p> :
      null}
      {inner}
    </div>;
  }
}

export default EditableImageUpload;
